module.exports = __webpack_public_path__ + "img/1507436413.33dba1f7.jpg";